module.exports = __webpack_public_path__ + "media/images/mymatrimony_logo-247bc05e06887d737478e2b9a0d1ac68.svg";